import { render, staticRenderFns } from "./list.vue?vue&type=template&id=3cd1d418&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=3cd1d418&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd1d418')) {
      api.createRecord('3cd1d418', component.options)
    } else {
      api.reload('3cd1d418', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=3cd1d418&", function () {
      api.rerender('3cd1d418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mvms/list.vue"
export default component.exports